import { EServices } from '../types/tableHelper'

/**
 * Сервисы, которые пользователь убрал из окна сравнения цен (VVT-232).
 *
 * Хранится у пользователя в браузере и отдельно на каждый Steam-аккаунт: на одном
 * компьютере может сидеть несколько человек, и чужой список скрытых площадок
 * сбивал бы с толку. Для незалогиненного используется общий ключ.
 *
 * Специально не на бэкенде: настройка сугубо личная и не влияет на данные, а
 * серверное хранение потребовало бы миграции и деплоя. Если понадобится
 * синхронизация между устройствами — переносится в user-settings без изменения UI.
 */
const KEY_PREFIX = 'pricecheck_hidden_'

const storageKey = (steamId?: string): string => `${KEY_PREFIX}${steamId || 'guest'}`

export const getHiddenServices = (steamId?: string): Set<EServices> => {
	try {
		const raw = localStorage.getItem(storageKey(steamId))
		if (!raw) return new Set()

		const parsed = JSON.parse(raw)
		if (!Array.isArray(parsed)) return new Set()

		// в хранилище мог остаться мусор или сервис, которого больше нет в enum
		return new Set(parsed.filter((x: unknown): x is EServices => typeof x === 'number' && EServices[x] !== undefined))
	} catch {
		return new Set()
	}
}

export const saveHiddenServices = (services: Set<EServices>, steamId?: string): void => {
	try {
		if (services.size === 0) localStorage.removeItem(storageKey(steamId))
		else localStorage.setItem(storageKey(steamId), JSON.stringify([...services]))
	} catch {
		/* приватный режим или заблокированное хранилище — не критично, скрытие просто не переживёт перезагрузку */
	}
}
